import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

 
  div {
    float: left;
    display: flex;
    flex-direction: column;

    small {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.TEXT1};

      i {
        margin: -5px 0 0 5px;
      }
    }

    p {
      font-size: 0.8rem;
      color: ${({ theme }) => theme.colors.TEXT4};
    }
  }

  @media (max-width: 1024px) {
    span {
      width: 3rem;
      height: 3rem;
      border-radius: 1.5rem;

      i {
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        margin: -3.4rem 0 0 1.5rem;
      }

      strong {
        width: 3rem;
        height: 3rem;
        border-radius: 1.5rem;
        font-size: 1rem;
        margin: 0 0.5rem 0 0;
      }
    }

    div {
      small {
        font-size: 1rem;
      }
      p {
        font-size: 0.8rem;
      }
    }
  }
`;
